var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"ban"}),_c('Company'),_c('Partner'),_c('Outlook')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }